import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';
import { ILinkData } from '../models/action/link';
import { ApiTypes } from '../models/enums/ApiTypes';

const T = Translator.create();
let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const _logger = Log.create('Link-Service');

export class HelpdeskService {

    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestGetMessageAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/helpdesk/message', params, token,false,ApiTypes.None)
        .then((responseChatData: Response) => {
            return responseChatData;
        }).then((result: any) => {
            return result;
        }).catch((responseChatData) => {
            _logger.data(' messag service error',responseChatData)
            return responseChatData;
        });
    }
    public async RequestGetListAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/helpdesk/list', params, token ).then((responseChatData: Response) => {
            return responseChatData;
        }).then((result: any) => {
            return result;
        }).catch((responseChatData) => {
            return responseChatData;
        });
    }
   
    public async RequestGetAssignedUserAsync(params:any) {
        return _apiClient.RequestAsync('GET', 'api/helpdesk/assignableusers',params,token).then((responseChatData: Response) => {
            return responseChatData;
        }).then((result: any) => {
            return result;
        }).catch((responseChatData) => {
            return responseChatData;
        });
    }

    //__________________________POST_______________________________

    public async RequestPostCreateAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/helpdesk/create', params, token,false,ApiTypes.None).then((responseCreateData: Response) => {
            return responseCreateData;
        }).then((result: any) => {
            return result;
        }).catch((error) => {
            return error;
        });
    }
    

}


